import { Col, Row, Typography } from 'antd'
import styled from 'styled-components'

export { CarbonEmissionsTooltip } from './CarbonEmissionsTooltip'

const { Text: AntText } = Typography

const CHART_HEIGHT = 285

export const MetricsContainer = styled(Row)`
  gap: 32px;
`

export const MetricContainer = styled(Col)`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  gap: 12px;
`

export const MetricLabel = styled(AntText)`
  color: ${({ theme }) => theme.colors.olive5};
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
`

export const ChartSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ChartHeader = styled.div`
  align-items: baseline;
  display: flex;
  gap: 8px;
`

export const ChartTitle = styled(AntText)`
  color: ${({ theme }) => theme.colors.olive5};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`

export const ChartUnit = styled(AntText)`
  color: ${({ theme }) => theme.colors.olive};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export const ChartContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.grey2};
  border-radius: ${({ theme }) => theme.foundation.borderRadius};
  box-sizing: border-box;
  height: ${CHART_HEIGHT}px;
  padding: 16px 12px 8px 0;
  width: 100%;
`

export const EmptyState = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`

export const EmptyStateText = styled(AntText)`
  color: ${({ theme }) => theme.colors.olive};
  font-size: 14px;
`
